// import moment from "moment";
import moment from "moment-timezone";
import { axiosGet } from "../../../../../../app/Helpers/AxiosHelper";
import { BASE_TASK } from "../../../../../../app/Config/ApiUrl";

import { SortedMixins } from "../../mixins/taskMixins";

// const parseJSON = (invalidJSON) => {
//   const jsonObject = JSON.parse(invalidJSON);
//   return jsonObject.form.forEach(item => {
//     if (item.name === "number") {
//       item.value = parseInt(item.value);
//     }
//   });
// }

export class Comment {
  constructor(params) {
    this.createdAt = params.created_at;
    this.updatedAt = params.updated_at;
    this.content = params.content;
    this.taskID = params.task_id;
    this.reply = params.reply;
    this.reply_comments = params.reply_comments;
    this.internal = params.internal;
    this.id = params.id;
    this.user = params.user;
  }
}

export class Notification {
  constructor(params) {

    this.id = params.id;
    this.has_read = params.has_read;
    this.created_at = moment(params.created_at).format("YYYY-MM-DD");
    this.updated_at = moment(params.updated_at).format("YYYY-MM-DD");
    this.time = new Date(params.created_at).toLocaleTimeString();
    this.models = params.models;
    this.object = params.object;
    this.owner = params.owner;
    this.parseOwner = `${params.owner.firstName} ${params.owner.lastName}`;

    this.message = params.message;
    this.content = params.content.message;
    this._content = params.content
    this.text = this.formatText()
  }

  updateNotification(property, new_value) {
    this[property] = new_value;
  }

  comment() {

  }

  formatText() {
    switch (this.models) {
      case "comments":
        const comment = {
          "title": "",
          "content": "",
        }
        if ("new" == this.message.activityType) {
          comment.title = `<strong>${this._content.owner}</strong> created a comment in the <strong>${this._content.task}</strong> task.`
          comment.content = this._content.content
        } else {
          comment.title = `<strong>${this._content.owner}</strong> updated a comment in the <strong>${this._content.task}</strong> task.`
          comment.content = this._content.content
        }
        return comment
      case "tasks":
        const task = {
          "title": "",
          "content": "",
        }
        if ("new" == this.message.activityType) {
          task.title = `<strong>${this._content.owner}</strong> created new task <strong>${this._content.task}</strong>.`
          task.content = this._content.task
        } else {
          task.title = `<strong>${this._content.owner}</strong> updated task <strong>${this._content.task}</strong> task.`
          const actions = this._content.actions.reduce((acc, action) => {

            if (action.title)
              acc = acc + `<li>${action.title} ${action.value}</li>`
            else
              acc = acc + action

            return acc
          }, "")
          task.content = `<ul style="list-style-type: none;">${actions}</ul>`
        }
        return task

      case "files":
        const file = {
          "title": "",
          "content": "",
        }
        if ("new" == this.message.activityType) {
          const taskAdd = this._content.task ? `in <strong>${this._content.task}</strong> task.` : `in <strong>${this._content.project}</strong> project.`
          file.title = `<strong>${this.parseOwner}</strong> created <strong>${this._content.file}</strong> file ${taskAdd}`
          file.content = ""
        } else {
          task.title = `<strong>${this.parseOwner}</strong> updated the <strong>${this._content.task}</strong> task.`
          const actions = this._content.actions.reduce((acc, action) => {

            if (action.title)
              acc = acc + `<li>${action.title} ${action.value}</li>`
            else
              acc = acc + action

            return acc
          }, "")
          task.content = `<ul style="list-style-type: none;">${actions}</ul>`
        }
        return file

      case "steps":
        const step = {
          "title": "",
          "content": "",
        }
        if ("new" == this.message.activityType) {
          step.title = `<strong>${this._content.owner}</strong> created new step <strong>${this._content.step}</strong>.`
          step.content = ""
        } else {
          // console.log(this.message)
          // step.title = `<strong>${this._content.owner}</strong> updated a step <strong>${this._content.task}</strong> to <strong>${this._content.task}</strong>.`
          // step.content = this._content.content
        }
        return step

      default:
        return {
          "title": "",
          "content": "",
        }

    }
  }


}

export class LogTimer {
  diff(hours = true) {
    const timing = parseInt(this.timeSpend / 60);
    if (hours) return timing;
    else return parseInt(this.timeSpend - timing * 60);
  }

  fullTime() {
    const hours = parseInt(this.timeSpend / 60);
    const minutes = parseInt(this.timeSpend - hours * 60);
    const seconds = this.timeSpend % 60

    return `${hours > 9 ? hours : "0" + hours}h${minutes > 9 ? minutes : "0" + minutes
      }m${seconds > 9 ? seconds : "0" + seconds}s`;
  }

  constructor(timer) {
    this.moment = moment(`${timer.date} ${timer.startTime}`).add(
      timer.timeSpend,
      "secondes"
    );
    this.exitDateTime = timer.exitDateTime,
      this.isClose = timer.isClose;
    this.top = timer.top;
    this.isRunning = timer.isRunning ? true : false;
    this.left = timer.left;
    this.id = timer.id;
    this.client = timer.client;
    this.createdAt = timer.createdAt;
    this.updatedAt = timer.updatedAt;
    this.description = timer.description;
    this.user = timer.user;
    this.timeSpend = timer.timeSpend;
    this.startedAt = timer.date;
    this.startedTime = timer.startTime;
    this.hours = this.diff();
    this.minutes = this.diff(false);
    this.seconds =
      parseInt(this.timeSpend) - (this.hours * 3600 + this.minutes * 60);
    this.fullTime = this.fullTime();
    this.project = timer.project;
    this.tags = timer.tags;
    this.newTags = timer.tags;
    this.taskID = timer.taskID;
    this.stepID = timer.stepID;

    this.task = {
      id: timer.task.id,
      title: timer.task.title,
      stepID: timer.stepID,
      // spentTime: timer.task.attributes.spent_time,
    };
  }
}


export class Task {
  #generalSettings = null;
  #requests = null;
  #original_title;


  constructor(params) {

    this.#requests = params.requestSettings
    this.#original_title = params.title;
    this.task_form_data = params.task_form_data
      ? (async () => {
        if (!params.task_form_data) return null;

        const json = JSON.parse(params.task_form_data);

        return {
          form: await Promise.all(
            JSON.parse(json).form.map(async (fo) => {
              if (!fo.isFile) return fo;

              return {
                ...fo,
                files: await axiosGet(`${BASE_TASK}/files/${fo.id}`).then(
                  ({ data }) => {
                    let _data = [];

                    if (!Array.isArray(data.data) && data.data !== null) {
                      const { id, attributes, relationships } = data.data;
                      const { users, file_comments } = relationships;

                      _data.push({
                        ...attributes,
                        id,
                        comments: file_comments.data,
                        tags: relationships.tags.data.map((tag) => {
                          return {
                            id: tag.id,
                            ...tag.attributes,
                          };
                        }),
                        owner: {
                          id: users.data.id,
                          ...users.data.attributes,
                        },
                      });
                    } else {
                      data.data.forEach((element) => {
                        const { id, attributes, relationships } = element;
                        const { users, file_comments } = relationships;

                        _data.push({
                          ...attributes,
                          id,
                          comments: file_comments.data,
                          tags: relationships.tags.data.map((tag) => {
                            return {
                              id: tag.id,
                              ...tag.attributes,
                            };
                          }),
                          owner: {
                            id: users.data.id,
                            ...users.data.attributes,
                          },
                        });
                      });
                    }

                    return _data;
                  },
                  (err) => err
                ),
              };
            })
          ),
        };
      })()
      : null;

    this.request_data = params.request_data
      ? (async () => {
        const incomingRequest = JSON.parse(params.request_data);
        const rawCategory = params.requestSettings.categories.find(
          (cat) => parseInt(cat.id) === parseInt(incomingRequest.category)
        );

        const rawSubcategory = rawCategory?.subcategories.find(
          ({ db_id }) => db_id === incomingRequest.subcategory
        );

        return {
          category: rawCategory?.category,
          task_user_id: rawCategory?.task_user_id,
          category_id: rawCategory?.id,
          subcategory: rawSubcategory?.subcategory,
          subcategory_id: rawSubcategory?.db_id ?? rawSubcategory?.id,

          form: await Promise.all(
            incomingRequest.form.map(async (fo) => {
              let rawForm = rawSubcategory?.form.find(
                (rawFo) => rawFo.id === fo.id
              );

              if (!rawForm && fo.file_id) {
                rawForm = {
                  id: fo.id,
                  label: "",
                  type: "file",
                  isFile: true,
                };
              }

              return rawForm
                ? {
                  ...fo,
                  id: rawForm.id,
                  label: rawForm.label,
                  type: rawForm.type,
                  isFile: rawForm.isFile,
                  files: rawForm.isFile
                    ? await axiosGet(
                      `${BASE_TASK}/files/${fo.file_id}`
                    ).then(
                      ({ data }) => {
                        let _data = [];

                        if (
                          !Array.isArray(data.data) &&
                          data.data !== null
                        ) {
                          const { id, attributes, relationships } =
                            data.data;
                          const { users, file_comments } = relationships;

                          _data.push({
                            ...attributes,
                            id,
                            comments: file_comments.data,
                            tags: relationships.tags.data.map((tag) => {
                              return {
                                id: tag.id,
                                ...tag.attributes,
                              };
                            }),
                            owner: {
                              id: users.data.id,
                              ...users.data.attributes,
                            },
                          });
                        } else {
                          data.data.forEach((element) => {
                            const { id, attributes, relationships } =
                              element;
                            const { users, file_comments } =
                              relationships;

                            _data.push({
                              ...attributes,
                              id,
                              comments: file_comments.data,
                              tags: relationships.tags.data.map((tag) => {
                                return {
                                  id: tag.id,
                                  ...tag.attributes,
                                };
                              }),
                              owner: {
                                id: users.data.id,
                                ...users.data.attributes,
                              },
                            });
                          });
                        }

                        return _data;
                      },
                      (err) => err
                    )
                    : null,
                }
                : rawForm;
            })
          ),
        };
      })()
      : null;

    this.progress = Math.ceil(
      ((params.subtasks_number - params.incomplete_subtasks_number) /
        (params.subtasks_number ? params.subtasks_number : 1)) *
      100
    );

    this.isRequest = params.is_request
    this.isForm = params.is_form

    this.position = params.position;
    this.created_at = moment(params.created_at).format('MMMM Do YYYY, h:mm:ss');
    this.updated_at = params.updated_at;
    this.started_at = params.started_at;
    this.project_name = params.project_name;
    this.started_at_clone = params.started_at;
    this.has_notification = params.has_notification;

    this.archivers = params.archivers;
    this.loading = false;
    this.files_number = params.files_number;
    // this.request_data = params.request_data;
    this.request_status = params.column != null ? params.column.name : null;
    this.cron_expression = params.cron_expression;

    this.added = params.added

    this.ticket = params.ticket_

    this.request_category =
      params.request_data != null
        ? params.requestSettings.categories.find(
          (cat) =>
            parseInt(cat.id) ===
            parseInt(JSON.parse(params.request_data).category)
        )?.category
        : null;
    this.request_subcategory =
      params.request_data != null
        ? params.requestSettings.categories
          .find(
            (cat) =>
              parseInt(cat.id) ===
              parseInt(JSON.parse(params.request_data).category)
          )
          ?.subcategories.find(
            (subcat) =>
              parseInt(subcat.db_id) ===
              parseInt(JSON.parse(params.request_data).subcategory)
          )?.subcategory
        : null;

    this.request_issuer =
      params.request_data != null ? params.clients[0].account : null;
    this.comments_number = params.comments_number;
    this.subtasks_number = params.subtasks_number;
    this.incomplete_subtasks_number = params.incomplete_subtasks_number;
    this.completed_subtasks_number =
      params.subtasks_number - params.incomplete_subtasks_number;
    this.description = params.description;
    this.column = params.column;
    this.approval_stage = params.approval_stage;
    this.title = params.title;
    this.task_system_id = params.task_system_id;
    this.due_date = params.due_date;
    this.due_date_clone = params.due_date;
    this.step_id = params.step_id;
    this.projectId = params.projectId;
    this.next_step_id = params.step_id;
    this.ticket_number = params.ticket_number;
    this.#generalSettings = params.generalSettings;
    this.owner = params.owner;
    this.is_follow = params.is_follow;
    this.is_completed = params.is_completed;
    this.isClosed = params.is_closed;
    this.id = params.id;
    this.priority = params.priority;
    this.estimated_time = params.estimated_time;

    this.assignees = params.assignees

    this.clients = params.clients;
    this.put_to_step = params.put_to_step;
    this.tags = params.tags;
    this.spentTime = params.spentTime;
    this.spentTimeInStep = this.parseTime(params.put_to_step);
    this.client_user = params.client_user
    this.hasOld = params.due_date
      ? moment(params.due_date) > moment()
        ? false
        : true
      : false;

    // this.onParseTitle()
  }

  get original_title() {
    return this.#original_title
  }

  parseTime(time) {
    if (time) {
      const timing = moment(time).tz(moment.tz.guess()).fromNow();
      return timing == "a few seconds ago"
        ? "Just few seconds ago"
        : `since ${timing}`;
    }
    return null;
  }
  getters(property) {
    return this[`#${property}`];
  }

  updateTask(property, new_value) {
    
    switch (property) {
      case "title":
        this.onParseTitle()

        break;

      case "request_data":

        if (new_value) {
          if (new_value instanceof Promise) {
            new_value.then((v) => {
              this.request_data = v;
              this.request_category = v.category;
            });
          } else {
            this.request_data = new_value;
          }
        } else this.request_data = null;

        break;

      case "subtask_compled":
        this.incomplete_subtasks_number = new_value
          ? this.incomplete_subtasks_number - 1
          : this.incomplete_subtasks_number + 1;
        this.completed_subtasks_number =
          this.subtasks_number - this.incomplete_subtasks_number;
        this.progress = Math.ceil(
          ((this.subtasks_number - this.incomplete_subtasks_number) /
            (this.subtasks_number ? this.subtasks_number : 1)) *
          100
        );

        break;

      default:
        this[property] = new_value;
        break;
    }

    return this
  }

  async resolveAll() {

    let promises = [this.task_form_data, this.request_data];

    Promise.all(promises)
      .then(([form, request]) => {

        if (form) this.task_form_data = form;

        if (request) {
          this.request_data = {
            ...request,
            form: request.form.filter((fo) => !!fo),
          };
        }

        this.onParseTitle()

        return {
          "task_form_data": this.task_form_data,
          "request_data": this.task_form_data,
        }
      })
      .catch((e) => console.log(e));
  }

  onParseTitle() {

    if (
      this.#generalSettings &&
      this.#generalSettings.hasOwnProperty("task attributes") && !!!this.task_system_id
    ) {

      const inputString = this.#generalSettings["task attributes"].content;

      if (!inputString)
        return this.title

      const ticket = {
        category: !this.ticket?.category ? null : this.#requests?.categories.find(
          (cat) =>
            parseInt(cat.id) ===
            parseInt(this.ticket?.category)
        )?.category,
        subcategory: !this.ticket?.subcategory ? null : this.#requests?.categories
          .find(
            (cat) =>
              parseInt(cat.id) ===
              parseInt(this.ticket?.category)
          )
          ?.subcategories.find(
            (subcat) => parseInt(subcat.db_id) === parseInt(this.ticket?.subcategory)
          )?.subcategory
      }

      const mastering = inputString.replace(/{{|}}/g, '')
        .replace(/task\.request_data\.category/g, ticket?.category || '')
        .replace(/task\.request\.locationId/g, this.clients[0]?.locationId || '')
        .replace(/task\.request\.sub_account_name/g, this.clients[0]?.sub_account_name || '')
        .replace(/task\.request_data\.subcategory/g, ticket?.subcategory || '')
        .replace(/task\.ticket_number/g, this.ticket_number || '')
        .replace(/task\.approval_stage/g, this.approval_stage || '')
        .replace(/task\.title/g, this.title || '')

      this.title = mastering

    }
  }
  replaceTask(task) {
    for (let tk in task) {
      this.updateTask(tk, task[tk]);
    }
  }

  deleteTask() { }

  clone() {
    return JSON.parse(
      JSON.stringify({ ...this, original_title: this.#original_title })
    );
  }

  addComment(comment) { }

  removeComment(commentID) { }

  startLoading(status) {
    if (status instanceof Boolean)
      throw new Error(`${status} should be a boolean`);
    this.loading = status;
  }
}

export class Step {
  constructor(params) {
    this.id = params.id;
    this.project_id = params.project_id;
    this.ids = params.ids;
    this.total = params.total;
    this.visible = params.visible ? params.visible : true;
    this.createdAt = params.created_at ? params.created_at : params.createdAt;
    this.updatedAt = params.updated_at ? params.updated_at : params.updatedAt;
    this.tasks = params.tasks;
    this.name = params.name;
    this.color = params.color;
    this.position = params.position;

    this.index = params.index;
    this.page = params.page ? params.page : 1;
    this.canLoad = params.canLoad ? params.canLoad : true;
    this.isLoading = params.isLoading ? params.isLoading : false;
  }

  loading(status) {
    if ("boolean" === typeof status)
      throw new Error(`${status} should be a boolean`);
    this.isLoading = status;
  }

  updateProperty(property, new_value) {
    this[property] = new_value;
  }

  addTasks(tasks, page, canBeLoad, paginate) {
    if (Array.isArray(tasks)) {
      this.tasks = [...this.tasks, ...tasks];
      // this.total = this.total + tasks.length
    } else {
      this.tasks = [...this.tasks, tasks];
      // this.total = this.total + 1
    }

    this.page = Math.ceil(this.tasks.length / paginate);
    this.canLoad = canBeLoad;
  }

  addTask(
    task,
    position = "push",
    index = null,
    replace = false,
    updateTotal = false
  ) {
    if (updateTotal) this.total = this.total + 1;

    if (task instanceof Task) {
      if (replace) {
        this.tasks[index] = task;
      } else {
        const existingIndex = this.tasks.findIndex((t) => t.id === task.id);
        if (existingIndex !== -1) {
          this.tasks[existingIndex] = task;
        } else {
          this.tasks[position](task);
        }
      }
    } else if (task instanceof Object) {
    
      const newTask = task
      const existingIndex = this.tasks.findIndex((t) => t.id === newTask.id);
      
      if (existingIndex !== -1) {
        this.tasks[existingIndex] = new Task(newTask);
      } else {
        if (replace) {
          this.tasks[index] = new Task(newTask);
        } else {
          if (index) this.tasks.splice(index, 0, new Task(newTask));
          else this.tasks[position](new Task(newTask));
        }
        // newTask.resolveAll();
      }
    }
  }

  clearTask() {
    this.tasks = [];
    this.total = 0;
  }

  removeTask(task_id) {
    this.tasks = this.tasks.filter(({ id }) => id !== task_id);
    this.total = this.total ? this.total - 1 : 0;
  }

  sortTask(criteria) {
    if (criteria)
      this.tasks = SortedMixins.methods.sorting(criteria, this.tasks);
  }

  positionSort() {
    return this.tasks.sort((a, b) => a.position - b.position);
  }

  updateStep() { }
}

export class Trigger {
  constructor(params) {
    this.createdAt = params.created_at;
    this.updatedAt = params.updated_at;
    this.title = params.title;
    this.status = params.status;
    this.isRunning = params.status == "running" ? true : false;
    this.triggerName = params.triggerName;
    this.id = params.id;
    this.options = params.options;
    this.triggerID = params.triggerID;
    this.tags = params.tags.split(",");
    this.fieldID = params.custom_field_id;
    this.default = params.default ? true : false;
    this.parseContacts(params.contacts);
  }

  parseContacts(data) {
    if (!data) return [];

    const contacts = JSON.parse(data);

    this.type = contacts.type ? contacts.type : null;
    this.email = contacts.email ? contacts.email : "";
  }
}

export class TaskForm {
  constructor(params) {
    this.createdAt = params.attributes.created_at;
    this.updatedAt = params.attributes.updated_at;
    this.projectID = params.attributes.project_id;
    this.stepID = params.attributes.step_id;
    this.userID = params.attributes.task_user_id;
    this.button = params.attributes.button
    this.form = params.attributes.form;
    this.id = params.id;
    this.step = params.attributes.step_id;
    this.name = params.attributes.name;
    this.assignees = params.relationships.assignees.data.map((user) => {
      user.title = user.attributes.first_name;
      return user;
    });
  }
}

export class Template {
  constructor(params) {
    this.createdAt = params.attributes.created_at;
    this.updatedAt = params.attributes.updated_at;
    this.projectID = params.attributes.project_id;
    this.triggerID = params.attributes.trigger_id;
    this.status = params.attributes.is_running ? true : false;
    this.state = params.attributes.is_running ? "running" : "stopped";

    this.global = params.attributes.is_global ? true : false;
    this.userID = params.attributes.task_user_id;

    this.userID = params.attributes.task_user_id;
    this.triggerName = params.relationships.triggers.data.attributes.name;

    this.title = params.attributes.title;
    this.id = params.id;
    this.body = params.attributes.body;
  }
}

export class Queue {
  constructor(elements = []) {
    this.queue = elements;
  }
  enqueue(element) {
    const data = Array.isArray(element) ? [...element] : [element];
    return this.queue.push(data);
  }

  dequeue() {
    if (this.queue.length > 0) {
      return this.queue.shift(); // remove first element
    }
  }

  isEmpty() {
    return this.queue.length == 0;
  }
}


